import { createFileRoute } from '@tanstack/react-router';

import { client } from '@@api/client';
import { handleLoaderError } from '@@router/handleLoaderError';

import { EditTagForm } from './-components/TagForm';

export const Route = createFileRoute('/_authenticated/tags/$id')({
    context: ({ params }) => ({
        tagQuery: client.metadata.tags.get.queryOptions(
            { params: { id: Number(params.id) } },
            { refetchOnWindowFocus: false },
        ),
    }),
    loader: ({ context }) =>
        context.queryClient
            .query({ ...context.tagQuery, staleTime: 'static' })
            .catch(handleLoaderError),
    component: EditTagForm,
});
